import { UnifiedAccServiceComponent } from './UnifiedAccServiceComponent';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
export const UnifiedAccReconnectionConfig = {
  reconnectButton: null,
  serviceComponent: UnifiedAccServiceComponent,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.CONNECTION_LOST]
};